<div class="dv-maincontent-wrap mt-4">
  <div
    class="row"
    *ngIf="displayType !== 'third_party' && activePaymentMethodsCounter > 1"
  >
    <div class="col" *ngIf="isCCEnabled">
      <button
        type="button"
        class="btn col-12"
        [ngClass]="
          displayType === 'credit_card' ? 'btn-success' : 'btn-primary'
        "
        (click)="togglePaymentDisplay('credit_card')"
      >
        Pay via Card
      </button>
    </div>
    <div class="col" *ngIf="isACHEnabled">
      <button
        type="button"
        class="btn col-12"
        [ngClass]="displayType === 'ach' ? 'btn-success' : 'btn-primary'"
        (click)="togglePaymentDisplay('ach')"
      >
        Pay via ACH
      </button>
    </div>
    <div class="col" *ngIf="isThirdPartyEnabled && !isRecurringForm">
      <button
        type="button"
        class="btn btn-primary col-12"
        (click)="togglePaymentDisplay('third_party')"
      >
        Pay via {{ activeThirdParties.join("/") }}
      </button>
    </div>
  </div>

  <div class="row" *ngIf="displayType === 'third_party'">
    <div class="col-md-12">
      <div class="custom-control custom-switch">
        <input
          id="paymentFormsAgreeTermsThirdParty"
          type="checkbox"
          class="custom-control-input"
          [(ngModel)]="agreedToTerms"
          [ngClass]="{ 'is-invalid': !agreedToTerms }"
          required
          name="agreedToTerms"
        />
        <label
          class="custom-control-label"
          for="paymentFormsAgreeTermsThirdParty"
        >
          I have read and agree to the
          <a
            id="paymentFormsOpenTermsAndConditionThirdParty"
            class="redify form-label-custom"
            href="javascript:void(0)"
            (click)="openThirdPartyTermsAndCondition()"
            >Terms and Conditions</a
          >. Information will be used as described here and in the
          <a
            id="paymentFormsOpenPolicyThirdParty"
            class="redify form-label-custom"
            href="javascript:void(0)"
            (click)="openThirdPartyPolicy()"
            >Privacy Policy</a
          >.
        </label>
      </div>
    </div>
    <div class="col-md-12 mb-3 mt-10">
      <app-google-pay-button
        #googlePayButtonComponent
        [gatewayMerchantId]="locationData?.MID"
        [googlePayMerchantId]="locationData?.GooglePayMerchantId"
        [amount]="amount"
        (tokenize)="processGooglePayResponse($event)"
        [canTokenize]="agreedToTerms && isFormValid"
      ></app-google-pay-button>
    </div>
    <div class="col-md-12 mb-2" *ngIf="isCCEnabled">
      <button
        type="button"
        class="btn btn-primary col-12"
        (click)="togglePaymentDisplay('credit_card')"
      >
        Pay via Card
      </button>
    </div>
    <div class="col-md-12" *ngIf="isACHEnabled">
      <button
        type="button"
        class="btn btn-primary col-12"
        (click)="togglePaymentDisplay('ach')"
      >
        Pay via ACH
      </button>
    </div>
  </div>
</div>
<div
  *ngIf="displayType === 'credit_card' && isCCEnabled"
  class="dv-maincontent-wrap"
>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="form-label-custom">Total</label>
          <input
            class="form-control form-field-custom"
            readonly
            value="{{ amount | currency }}"
            placeholder="$0.00"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label-custom"
            >Card holder name
            <span class="payment-field-required">*</span></label
          >
          <input
            type="text"
            class="form-control form-field-custom"
            [(ngModel)]="firstName"
            placeholder="First Name"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>&nbsp;</label>
          <input
            type="text"
            class="form-control form-field-custom"
            [(ngModel)]="lastName"
            placeholder="Last Name"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label-custom"
            >Email Address <span class="payment-field-required">*</span>
          </label>
          <input
            type="text"
            class="form-control form-field-custom"
            [(ngModel)]="email"
            placeholder="Email Address"
          />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label class="form-label-custom">Contact No / Mobile </label>
          <input
            type="text"
            class="form-control form-field-custom"
            [(ngModel)]="phone"
            placeholder="Contact Number"
            (keyup)="onMobileNumberKeyup($event.target.value)"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
          />
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <div
    class="heartland-payment-type"
    [hidden]="!(displayType === 'credit_card' && isCCEnabled)"
  >
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="credit-card-card-number"
            >Card Number <span class="payment-field-required">*</span></label
          >
          <div id="credit-card-card-holder" [hidden]="true"></div>
          <div id="credit-card-card-number"></div>
        </div>
      </div>
    </div>
    <div class="row row-mobile">
      <div class="col-md-6">
        <div class="form-group">
          <label for="credit-card-card-expiration"
            >Card Expiration
            <span class="payment-field-required">*</span></label
          >
          <div id="credit-card-card-expiration"></div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="credit-card-card-cvv"
            >Card CVV <span class="payment-field-required">*</span></label
          >
          <div id="credit-card-card-cvv"></div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="dv-maincontent-wrap"
    *ngIf="
      !isRecurringForm &&
      !hasCommercialItem &&
      displayType === 'credit_card' &&
      isCCEnabled &&
      isShowRememberCard
    "
  >
    <div
      class="col-md-12"
      [class.saveCardcheck-visible]="moduleType == 'subscriptionModule'"
    >
      <div class="row">
        <div class="col-md-12">
          <label class="label-chk bold form-label-custom">
            <input type="checkbox" [(ngModel)]="saveCard" /> Remember card to my
            Account
          </label>
        </div>
      </div>
    </div>
  </div>

  <div
    class="dv-maincontent-wrap"
    *ngIf="displayType === 'ach' && isACHEnabled"
  >
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label-custom">Total</label>
            <input
              [ngClass]="{ disabled: !isACHEnabled }"
              class="form-control form-field-custom"
              readonly
              value="{{ amount | currency }}"
              placeholder="$0.00"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label-custom"
              >Account Number
              <span class="payment-field-required">*</span></label
            >
            <input
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="achPaymentModel.AccountNumber"
              placeholder="Account Number"
              [ngClass]="{
                'is-invalid': !achPaymentModel.AccountNumber,
                disabled: !isACHEnabled
              }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-label-custom"
              >Routing Number
              <span class="payment-field-required">*</span></label
            >
            <input
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="achPaymentModel.RoutingNumber"
              placeholder="Routing Number"
              [ngClass]="{
                'is-invalid': !achPaymentModel.RoutingNumber,
                disabled: !isACHEnabled
              }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label-custom"
              >Account Type <span class="payment-field-required">*</span></label
            >
            <select
              [ngClass]="{ disabled: !isACHEnabled }"
              name="accountTypeSelect"
              class="form-control form-field-custom"
              [(ngModel)]="achPaymentModel.AccountType"
              (change)="accountTypeChanged($event)"
            >
              <option value="0" selected="true">Checking</option>
              <option value="1">Savings</option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group" *ngIf="isCheckingAccount">
            <label class="form-label-custom"
              >Check Type <span class="payment-field-required">*</span></label
            >
            <select
              [ngClass]="{
                disabled: !isACHEnabled,
                'is-invalid':
                  achPaymentModel.CheckType === undefined ||
                  achPaymentModel.CheckType === null ||
                  achPaymentModel.CheckType === ''
              }"
              class="form-control form-field-custom"
              (change)="checkTypeChanged($event)"
              [(ngModel)]="achPaymentModel.CheckType"
            >
              <option value="">--- Select Check Type ---</option>
              <option value="0">PERSONAL</option>
              <option value="1">BUSINESS</option>
              <option value="2">PAYROLL</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label-custom"
              >Check Holder Name
              <span class="payment-field-required">*</span></label
            >
            <input
              [ngClass]="{
                'is-invalid': !firstName,
                disabled: !isACHEnabled
              }"
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="firstName"
              placeholder="First Name"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>&nbsp;</label>
            <input
              [ngClass]="{ disabled: !isACHEnabled }"
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="lastName"
              placeholder="Last Name"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label-custom"
              >Email Address <span class="payment-field-required">*</span>
            </label>
            <input
              [ngClass]="{
                'is-invalid': !email,
                disabled: !isACHEnabled
              }"
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="email"
              placeholder="Email Address"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label-custom">Contact No / Mobile </label>
            <input
              [ngClass]="{ disabled: !isACHEnabled }"
              type="text"
              class="form-control form-field-custom"
              [(ngModel)]="phone"
              placeholder="Contact Number"
              (keyup)="onMobileNumberKeyup($event.target.value)"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="label-chk">
              <label class="label-chk bold form-label-custom">
                <!-- isRequireTermsPolicy &&  -->
                <input
                  [ngClass]="{
                    'is-invalid': !agreedToTerms,
                    disabled: !isACHEnabled
                  }"
                  type="checkbox"
                  [required]="isRequireTermsPolicy"
                  [(ngModel)]="agreedToTerms"
                />
                I have read and agree to the
              </label>
              <a
                class="redify bold form-label-custom ml-1"
                href="javascript:void(0)"
                (click)="openTermsAndCondition()"
              >
                Terms and Conditions</a
              >
              &nbsp;<span class="payment-field-required">*</span>
              <br />
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal for third party T&C and Policy -->
<ng-template #container>
  <div
    class="modal-content modal-content-right"
    id="invoicePaymentSelectionModal"
  >
    <div class="modal-header">
      <h1 class="modal-title pull-left">{{ tcpTitle }}</h1>
      <button
        id="invoicePaymentSelectionCloseModal"
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="closeCurrentDialog()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div [innerHTML]="tcpContent" class="tcp-content text-secondary"></div>
    </div>
  </div>
</ng-template>
